module.exports = __webpack_public_path__ + "img/start_game.2b129a96.jpg";